import React from 'react'
import styled from '@emotion/styled'
import { FilePreview } from '@ow/comps'
import { fileTypeImg } from '../../utils/file-constants'
import downloadImg from '../../assets/media/download.png'
import deleteImg from '../../assets/media/delete.png'

const Item = styled.div`
  &:hover .delete-icon {
    visibility: visible !important;
  }
`

const fileExtension = (url) => {
  const index = url.lastIndexOf('.')
  return url.substr(index + 1)
}

const FileItem = ({ files, file, index, deleteFile }) => {
  const { filename, src, fileType } = file
  return (
    <Item
      className="relative flex items-center w-1/2 bg-gray-100 z-10 h-9 leading-9 px-3 mb-2 box-border  dark:border-darkTheme-800 dark:bg-darkTheme-1100 dark:border dark:border-solid"
      style={{ borderRadius: '.25rem', fontSize: '.75rem' }}
    >
      <div className="w-full flex items-center truncate">
        <span
          onClick={() => {
            FilePreview.preview(files, index)
          }}
        >
          <img
            alt=""
            src={fileTypeImg[fileType || fileExtension(src)]}
            className="w-4 h-5"
            style={{ marginRight: '.375rem' }}
          />
        </span>
        <span className="w-4/5 truncate">{filename}</span>
      </div>
      <a
        className="w-4 h-4 -ml-3"
        href={`${src}?response-content-type=application/octet-stream`}
      >
        <img src={downloadImg} className="w-full h-full" alt="" />
      </a>
      <span
        className="delete-icon absolute -top-1.5 -right-1.5 text-red-2 cursor-pointer"
        style={{
          visibility: 'hidden',
        }}
        onClick={() => deleteFile(file, index)}
      >
        <img src={deleteImg} className="w-4 h-4" alt="" />
      </span>
    </Item>
  )
}

export default FileItem
